import request from '../utils/request';
import { resolveNetworkType } from '../utils/network';

/** 查询日志分组列表（按 VIN + 日期分组） */
export function fetchLogGroups(params = {}) {
  return request.get('/logs/groups', { params });
}

/** 查询日志列表（平铺，单条记录） */
export function fetchLogList(params = {}) {
  return request.get('/logs', { params });
}

export function fetchLogDetail(id) {
  return request.get(`/logs/${id}`);
}

/** 获取 MinIO 预签名下载 URL（浏览器直下，不经后端中转） */
export async function fetchLogDownloadUrl(objectName, options = {}) {
  // 显式 internal 参数优先；否则按顶栏所选网络通道
  const useInternal = typeof options.internal === 'boolean'
    ? options.internal
    : resolveNetworkType() === 'internal';

  const params = { object_name: objectName, network_type: useInternal ? 'internal' : 'external' };
  return request.get('/logs/download-url', { params });
}

/** 删除单条日志记录（PostgreSQL + MinIO 文件） */
export function deleteLogRecord(objectName, password) {
  return request.post('/logs/delete', { object_name: objectName, password });
}
